import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Clock, Award, UserCheck, ArrowRight, Lock, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToCombos = () => {
    const combosSection = document.getElementById('combos');
    if (combosSection) {
      combosSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative overflow-hidden bg-[#fafaf9] pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-41">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-43">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 max-w-2xl text-center lg:text-left" data-id="element-44">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-sm font-bold mb-6 border border-orange-200" data-id="element-45">
              <UserCheck className="w-4 h-4" data-id="element-46" />
              🔥 +1.578 personas ya multiplicaron sus plantas
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-47">
              ¿Cuánto dinero gastaste en plantas que{' '}
              <span className="text-[#4a7c2c]" data-id="element-48">
                podrías haber tenido gratis?
              </span>
            </h1>

            <p className="text-lg text-gray-600 mb-4 leading-relaxed" data-id="element-49">
              Cada planta que compraste en el vivero, en la feria o por internet
              — si hubieras sabido lo que estás por aprender — podrías haberla
              multiplicado en 10, 20 o 50 ejemplares idénticos.
            </p>

            <p className="text-base text-gray-500 mb-8 leading-relaxed" data-id="element-50">
              Se llama{' '}
              <strong className="text-gray-700" data-id="element-51">
                propagación por esquejes
              </strong>
              . Es una técnica que existe hace siglos, que usan los viveros más
              grandes del mundo, y que cualquier persona puede aprender en un
              fin de semana.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-52">
              {[{
              icon: UserCheck,
              text: 'Ideal para principiantes'
            }, {
              icon: Clock,
              text: 'Acceso inmediato'
            }, {
              icon: CheckCircle2,
              text: 'Método probado'
            }, {
              icon: Award,
              text: 'Sin experiencia previa'
            }].map((item, index) => <div key={index} className="flex items-center gap-2 text-gray-700" data-id="element-53">
                  <item.icon className="w-5 h-5 text-[#6b9d3e]" data-id="element-54" />
                  <span className="text-sm font-medium" data-id="element-55">{item.text}</span>
                </div>)}
            </div>

            <div className="flex flex-col gap-3" data-id="element-56">
              <Button className="text-lg px-8 py-4 w-full sm:w-auto group shadow-xl shadow-[#4a7c2c]/20 hover:shadow-[#4a7c2c]/30 transition-all" onClick={scrollToCombos} data-id="element-57">
                Quiero multiplicar mis plantas →
              </Button>

              <div className="flex items-center justify-center lg:justify-start gap-2 text-xs text-gray-500 mt-2" data-id="element-58">
                <Lock className="w-3 h-3" data-id="element-59" />
                <span data-id="element-60">
                  Pago seguro con tarjeta, transferencia, débito o efectivo
                </span>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs font-medium text-gray-500" data-id="element-61">
              <div className="flex items-center gap-1.5" data-id="element-62">
                <ShieldCheck className="w-4 h-4 text-[#4a7c2c]" data-id="element-63" />
                Compra protegida por Hotmart
              </div>
              <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-64"></div>
              <div className="flex items-center gap-1.5" data-id="element-65">
                <CheckCircle2 className="w-4 h-4 text-[#4a7c2c]" data-id="element-66" />7 días de
                garantía
              </div>
              <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-67"></div>
              <div className="flex items-center gap-1.5" data-id="element-68">
                <Clock className="w-4 h-4 text-[#4a7c2c]" data-id="element-69" />
                Acceso inmediato
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-70">
            <div className="relative z-10 rounded-2xl shadow-2xl overflow-hidden bg-white p-2 sm:p-4 rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-71">
              <img src="https://cdn.magicpatterns.com/uploads/h45ZLkfyEb6KobfDUcdtpV/ChatGPT_Image_19_ene_2026,_03_20_12.png" alt="Guía de Esquejes Libro" className="w-full h-auto rounded-lg" data-id="element-72" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#6b9d3e]/20 rounded-full blur-3xl -z-10" data-id="element-73" />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#4a7c2c]/20 rounded-full blur-3xl -z-10" data-id="element-74" />
          </motion.div>
        </div>
      </div>
    </section>;
}